import styled from "styled-components"

import CursorInvertUrl from "../../svg/cursor-active-invert.svg"

export const Container = styled.div`
  background: var(--color-primary);
  padding: 5% 10% 200px 10%;
  color: var(--white);

  a,
  input,
  textarea,
  label[for],
  select,
  button {
    cursor: url(${CursorInvertUrl}) 90 12, auto;
  }
`

export const Badge = styled.div`
  width: 60vw;
  position: relative;
  margin: 0 0 0 auto;
  height: 30vmax;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BadgeTitle = styled.h1`
  margin: auto;
  width: 40%;
  z-index: 1;
  text-align: center;
  color: var(--white);
  font-size: 4.5vw;
`

export const StarBadgeContainer = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
`

export const SecretEmailLink = styled.div`
  display: flex;
  margin: 5% 0;

  a {
    margin-left: auto;
    color: var(--white);
    font-size: 9px;
  }
`

export const Form = styled.form`
  margin: auto;
  color: var(--white);
`

export const Label = styled.label`
  font-size: var(--h1);
  color: var(--white);
  display: block;
  margin-bottom: 2%;
`

export const FormElement = styled.div`
  margin-bottom: 2%;
`

export const Textarea = styled.textarea`
  border: none;
  width: 100%;
  resize: none;
  outline: none;
  font-size: var(--h3);
  color: var(--white);
  text-transform: uppercase;
  background-image: linear-gradient(
    var(--blue) 35px,
    var(--white) 35px,
    var(--white) 36px,
    var(--blue) 36px
  );
  line-height: 37px;
  background-size: 100% 37px;
`

export const Button = styled.button`
  background: none;
  border: none;
  font-size: var(--h1);
  text-transform: uppercase;
  color: white;
  text-decoration: underline;
  position: relative;
  ::after {
    content: "→";
    position: absolute;
    left: -5rem;
    bottom: -5rem;
    transform: rotate(-45deg);
    color: white;
    font-size: 5rem;
  }
`
